import { Box } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { VendorOnboardingForm } from '../interfaces'

/**
 * Honeypot. Bots fill inputs by guessing from the `name` attribute, so this one is
 * called "website" to look worth filling. Anything typed here makes n8n discard the
 * submission — while still returning a normal success, so the bot gets no signal
 * that it was caught.
 *
 * Hidden with clip/offset rather than `display:none` or `type="hidden"`, both of
 * which the better bots know to skip. tabIndex/aria-hidden keep it away from
 * keyboard and screen-reader users, who would otherwise trip it by accident.
 */
const HoneypotField = () => {
    const { register } = useFormContext<VendorOnboardingForm>()

    return (
        <Box
            aria-hidden="true"
            sx={{
                position: 'absolute',
                // Must be '1px' strings: in MUI's sx a bare `1` is the fractional
                // shorthand for 100%, which made this box full-width and pushed its
                // input off-screen, causing horizontal scroll on mobile.
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0 0 0 0)',
                whiteSpace: 'nowrap',
                border: 0,
            }}
        >
            <label htmlFor="website">Website (leave this field empty)</label>
            <input
                id="website"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                {...register('website')}
            />
        </Box>
    )
}

export default HoneypotField
